import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { addressId } = useLocalSearchParams<{ addressId: string }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Delivery Menu — {addressId}</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
